(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rev6-racing-showcase"] && !Shopify.designMode) return;
  try {
    
const photos=[['hardware','Fork caps and steering-stem nut concept'],['left','Left angled view'],['right','Right angled view'],['detail','Close-up clamp view'],['cockpit','Cockpit installation concept'],['overhead','Overhead cockpit view']];
let active=0;
const hero=document.querySelector('#hero'),dialog=document.querySelector('#lightbox'),large=document.querySelector('#largeImage');
const thumbs=document.querySelector('#thumbnails');
photos.forEach(([file,alt],i)=>{const b=document.createElement('button');b.setAttribute('aria-label','Show '+alt);b.innerHTML='<img src="https://cdn.shopify.com/s/files/1/0775/1876/6234/files/rev6-'+file+'.png" alt="" loading="lazy">';b.onclick=()=>show(i);thumbs.append(b)});
function show(i){active=(i+photos.length)%photos.length;const [file,alt]=photos[active];hero.src=large.src='https://cdn.shopify.com/s/files/1/0775/1876/6234/files/rev6-'+file+'.png';hero.alt=large.alt=alt;document.querySelector('#photoCount').textContent=document.querySelector('#largeCount').textContent=String(active+1).padStart(2,'0')+' / 06';[...thumbs.children].forEach((b,j)=>b.setAttribute('aria-pressed',String(j===active)))}
document.querySelector('#previous').onclick=document.querySelector('#largePrevious').onclick=()=>show(active-1);
document.querySelector('#next').onclick=document.querySelector('#largeNext').onclick=()=>show(active+1);
document.querySelector('#openImage').onclick=()=>dialog.showModal();
document.querySelector('.close').onclick=()=>dialog.close();
document.querySelectorAll('[data-photo]').forEach(b=>b.onclick=()=>{show(Number(b.dataset.photo));dialog.showModal()});
dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight')show(active+1);if(e.key==='ArrowLeft')show(active-1)});
show(0);

function rev6TrackImage(image) {
  if (image.dataset.rev6Tracked) return;
  image.dataset.rev6Tracked = 'true';
  let timeout;
  const finish = () => {
    clearTimeout(timeout);
    image.classList.remove('rev6-image-loading');
    image.removeAttribute('aria-busy');
  };
  const start = () => {
    clearTimeout(timeout);
    if (image.complete) { finish(); return; }
    image.classList.add('rev6-image-loading');
    image.setAttribute('aria-busy', 'true');
    timeout = setTimeout(finish, 20000);
  };
  image.addEventListener('load', () => { if (image.complete) finish(); });
  image.addEventListener('error', () => { if (image.complete) finish(); });
  const observer = new MutationObserver(start);
  observer.observe(image, {attributes:true, attributeFilter:['src','srcset']});
  start();
}
function rev6InitSkeletons(root = document) {
  root.querySelectorAll('#hero,#largeImage,.thumbnails img,.editorial img').forEach(rev6TrackImage);
}
rev6InitSkeletons();
document.addEventListener('shopify:section:load', event => rev6InitSkeletons(event.target));


  } catch(e) { console.error(e); }
})();
})();
